import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'Context/QueryClientContext';
import ObrasApi from 'Data/Obras.api';
import { IObraResponse } from 'Data/interfaces/Obra/IObraListResponse';
import toastHandler from 'Utils/toastHandler';
import { OBRA_QUERY_KEY } from 'Data/keys/QueryKeys';
import { createError, createSuccess, updateError, updateSuccess } from 'Utils/Messages';
import { IDisciplineRequest } from 'Data/interfaces/Obra/IDisciplineRequest';

export const useQueryCreateOrUpdateDiscipline = () => {
  const { mutate, mutateAsync, isPending } = useMutation({
    mutationFn: (variables: IDisciplineRequest) => {
      return ObrasApi.createOrUpdateDiscipline(variables);
    },
    onSuccess: async ({ data }, variables) => {
      await queryClient.cancelQueries({
        queryKey: [OBRA_QUERY_KEY, Number(data.data.ConstructionSiteFk)],
      });

      queryClient.setQueryData<IObraResponse[]>([OBRA_QUERY_KEY], (old) => {
        return old?.map((obra) => {
          if (
            obra.ConstructionSiteId === data.data.ConstructionSiteFk &&
            obra.Disciplines && obra.Disciplines.length > 0
          ) {
            const index = obra.Disciplines.findIndex((discipline: any) => {
              return discipline.ConstructionSiteDisciplinesId === data.data.ConstructionSiteDisciplinesId;
            });
            if (index !== -1) {
              obra.Disciplines[index] = data.data;
            } else {
              obra.Disciplines = [...obra.Disciplines, data.data];
            }
          }
          return obra;
        });
      });
      queryClient.setQueryData<IObraResponse>(
        [OBRA_QUERY_KEY, Number(data.data.ConstructionSiteFk)],
        (old) => {
          if (old) {
            const index = old.Disciplines.findIndex((discipline: any) => {
              return discipline.ConstructionSiteDisciplinesId === data.data.ConstructionSiteDisciplinesId;
            });
            if (index !== -1) {
              old.Disciplines[index] = data.data;
            } else {
              old.Disciplines = [...old.Disciplines, data.data];
            }
          }
          return old;
        },
      );

      const msg = variables.Id
        ? updateSuccess('disciplina')
        : createSuccess('disciplina');
      toastHandler.handler({ description: msg, icon: 'success', title: '' });
    },
    onError: async (error: any, variables) => {
      const errorMsg = error.errors
        ? error.errors[0].Message
        : variables.Id ? updateError('disciplina') : createError('disciplina');
      toastHandler.showError(errorMsg);
    },
  });

  return {
    createOrUpdateDiscipline: mutate,
    createOrUpdateDisciplineAsync: mutateAsync,
    isLoading: isPending,
  };
};
